/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {MDXWrapper} from 'lib/mdx';
import Image from 'next/image';
import ImageTabs from 'components/image-tabs';
import Accordion from 'components/accordion';
import startRecording from '../public/how-to/zoom/1-start-recording.png';
import recordedMeetings from '../public/how-to/zoom/2-recorded-meetings.png';
import uploadFiles from '../public/how-to/zoom/3-upload-files.png';
import dragToUpload from '../public/how-to/zoom/4-drag-to-upload.png';
export const metadata = {
  title: 'Transcribe a Zoom Recording',
  description: 'Transcribe any Zoom meeting recording by following this easy step-by-step guide to using the TranscribeKit speech-to-text add-on for Google Drive'
};
const MDXLayout = function Layout({children}) {
  return _jsx(MDXWrapper, {
    metadata: metadata,
    children: children
  });
};
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h1: "h1",
      p: "p",
      em: "em",
      a: "a",
      h2: "h2",
      strong: "strong"
    }, props.components);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h1, {
        children: "How to Transcribe a Zoom Meeting Recording"
      }), "\n", _jsxs(_components.p, {
        children: ["With ", _jsx(_components.em, {
          children: "TranscribeKit"
        }), " you can transcribe any ", _jsx(_components.a, {
          href: "https://zoom.us/",
          target: "_blank",
          rel: "nofollow noopener noreferrer",
          children: _jsx(_components.em, {
            children: "Zoom"
          })
        }), " recording in one of our 59 supported languages and only pay for what you transcribe. Follow these steps to create a text transcript of your meeting."]
      }), "\n", _jsx("div", {
        className: "mb-2 mx-3",
        children: _jsx(Accordion, {
          header: "Can Zoom transcribe a meeting?",
          children: _jsxs(_components.p, {
            children: ["Yes, ", _jsx(_components.em, {
              children: "Zoom"
            }), " itself can automatically transcribe your meeting to text but this feature is only available on their ", _jsx(_components.em, {
              children: "Business"
            }), " plan and only supports English. With ", _jsx(_components.em, {
              children: "TranscribeKit"
            }), ", however, you can transcribe ", _jsx(_components.em, {
              children: "Zoom"
            }), " meetings in 59 different languages and you only pay for what you need to transcribe."]
          })
        })
      }), "\n", _jsxs(_components.h2, {
        children: ["1. Record your ", _jsx(_components.em, {
          children: "Zoom"
        }), " meeting"]
      }), "\n", _jsxs(_components.p, {
        children: ["Start your meeting and click on the ", _jsx(_components.strong, {
          children: "Record"
        }), " button at the bottom. If a menu pops up then choose ", _jsx(_components.strong, {
          children: "Record on this Computer"
        }), ". After you end the meeting a folder containing the audio and video files will pop up."]
      }), "\n", _jsx("div", {
        className: "flex justify-center",
        children: _jsx("div", {
          className: "flex w-max",
          children: _jsx(Image, {
            src: startRecording,
            alt: "Start recording",
            quality: 100,
            placeholder: "blur",
            priority: true
          })
        })
      }), "\n", _jsx(_components.p, {
        children: _jsxs(_components.em, {
          children: ["If you need to come back to an existing recording later then in Zoom you can click on ", _jsx(_components.strong, {
            children: "Meetings"
          }), " and then ", _jsx(_components.strong, {
            children: "Recorded"
          }), ". Click your meeting in the list and then click ", _jsx(_components.strong, {
            children: "Open"
          }), " to open the folder containing the files."]
        })
      }), "\n", _jsx("div", {
        className: "flex justify-center",
        children: _jsx("div", {
          className: "flex border w-max",
          children: _jsx(Image, {
            src: recordedMeetings,
            alt: "Recorded meetings",
            quality: 100,
            placeholder: "blur",
            priority: true
          })
        })
      }), "\n", _jsxs(_components.p, {
        children: ["If you have any issues then ", _jsxs(_components.a, {
          href: "https://support.zoom.us/hc/en-us/articles/201362473-Local-recording",
          target: "_blank",
          rel: "nofollow noopener noreferrer",
          children: ["click here for ", _jsx(_components.em, {
            children: "Zoom's"
          }), " full recording guide"]
        })]
      }), "\n", _jsxs(_components.h2, {
        children: ["2. Upload the audio file to ", _jsx(_components.em, {
          children: "Google Drive"
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["You should now have a folder containing the meeting recording. There should be at least one file named ", _jsx(_components.strong, {
          children: "audio_only"
        }), " which is what you need to transcribe. There could be multiple files if you stopped and started the recording during the meeting so double-click the file to play it and check its contents. There should also be a video file named ", _jsx(_components.strong, {
          children: "zoom_0"
        }), ". You could transcribe this instead but it will take longer to upload since video files are larger."]
      }), "\n", _jsxs(_components.p, {
        children: ["Now that you have the audio file you can click ", _jsx(_components.a, {
          href: "https://drive.google.com",
          target: "_blank",
          rel: "nofollow noopener noreferrer",
          children: "here"
        }), " to open ", _jsx(_components.em, {
          children: "Google Drive"
        }), " in a new tab. If you don't already have a ", _jsx(_components.em, {
          children: "Google"
        }), " account then you can create one for free."]
      }), "\n", _jsxs(_components.p, {
        children: ["The easiest way to upload is to drag and drop the ", _jsx(_components.strong, {
          children: "audio_only"
        }), " file onto your ", _jsx(_components.em, {
          children: "Drive"
        }), " (see image below)."]
      }), "\n", _jsx(_components.p, {
        children: _jsxs(_components.em, {
          children: ["If that doesn't work for some reason then click ", _jsx(_components.strong, {
            children: "New"
          }), " and then ", _jsx(_components.strong, {
            children: "File upload"
          }), ". Now select your ", _jsx(_components.strong, {
            children: "Documents"
          }), " folder, inside it should be a ", _jsx(_components.strong, {
            children: "Zoom"
          }), " folder and inside that you can find your recorded meetings."]
        })
      }), "\n", _jsx("div", {
        className: "flex justify-center",
        children: _jsx(ImageTabs, {
          images: [{
            image: dragToUpload,
            caption: 'Drag to upload'
          }, {
            image: uploadFiles,
            caption: 'Alternative file upload'
          }]
        })
      }), "\n", _jsxs(_components.p, {
        children: ["If you have any issues then ", _jsxs(_components.a, {
          href: "https://support.google.com/drive/answer/2424384",
          target: "_blank",
          rel: "nofollow noopener noreferrer",
          children: ["click here for ", _jsx(_components.em, {
            children: "Google's"
          }), " full guide to ", _jsx(_components.em, {
            children: "Google Drive"
          })]
        })]
      }), "\n", _jsx(_components.h2, {
        children: "3. Request a transcription"
      }), "\n", _jsxs(_components.p, {
        children: ["Once your recording is uploaded to ", _jsx(_components.em, {
          children: "Google Drive"
        }), " you can transcribe it using the ", _jsx(_components.em, {
          children: "TranscribeKit"
        }), " add-on. ", _jsx(_components.a, {
          href: "/how-to-transcribe",
          children: "Click here for the full step-by-step guide"
        })]
      }), "\n", _jsx(_components.h2, {
        children: "Related Articles"
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.a, {
          href: "/how-to-transcribe",
          children: "How to Transcribe Audio or Video to Text"
        })
      })]
    });
  }
}
export default MDXContent;
